




















































































import theme from '@zk/theme/lib/variables.scss';
import { defineComponent, toRef, ref, computed } from '@vue/composition-api';

import TheLayoutArea from './TheLayoutArea.vue';
import { useFieldLayout } from '../store';
import { unusedAreaFieldModel, LayoutFieldItem } from '../model/layout';
import { useDebounceFn } from '@vueuse/core';
import pinyinMatch from 'pinyin-match';
import { differenceBy, without, unionBy } from 'lodash';
import { FIXED_SORT_FIELDS } from '../common/config';

// import { useDeleteField } from '../store/deleteField';
// import { createLoadingEvent } from '@zk/framework-vue';

export default defineComponent({
  name: 'TheFieldListArea',
  components: {
    TheLayoutArea
  },
  props: {
  },
  setup() {
    const store = useFieldLayout();
    const searchVo = ref<string>();

    const unusedFields = toRef(store, 'unusedAreaFields');

    // 是否正在搜索未使用字段
    const isSearching = computed(() => searchVo.value?.length > 0);

    const fields = computed(() => {
      return isSearching.value
        ? unusedFields.value.filter(
          (f: unusedAreaFieldModel) => f.customFieldName.includes((searchVo.value || ''))
          || pinyinMatch.match(f.customFieldName, searchVo.value)
        )
        : unusedFields.value;
    });

    // 备选列表拖拽后数据更新
    const onUpdate = (list: LayoutFieldItem[] = []): void => {
      if (!isSearching.value) {
        const isMoveIn = list.length > unusedFields.value.length;
        const diffField = IgnoreOrderDifferenceBy(unusedFields.value, list, 'customFieldId');
        const newFields: LayoutFieldItem[] = isMoveIn 
          ? unionBy(diffField.map(f => ({ ...f, requiredFlag: 0 })), list, 'customFieldId') 
          : list;
        store.updateLayoutField(newFields, 'unused');
        return;
      }

      // 搜索情况下更新数据
      const diffFields = IgnoreOrderDifferenceBy(fields.value, list, 'customFieldId');
      if (fields.value.length > list?.length) {
        diffFields && store.updateLayoutField(without(unusedFields.value, ...diffFields), 'unused');
        return;
      }
      // 移入字段
      store.updateLayoutField(
        unionBy(diffFields.map(f => ({ ...f, requiredFlag: 0 })), unusedFields.value, 'customFieldId'), 
        'unused'
      );
    };
    
    const IgnoreOrderDifferenceBy = (list1: LayoutFieldItem[] = [], list2: LayoutFieldItem[] = [], code: string) => {
      return differenceBy(list1, list2, code).concat(differenceBy(list2, list1, code));
    };

    // 检测字段是否可以通过拖拽移除
    const dragPutInspection = () => {
      const { controlCode, fieldCode: _fieldCode } = store.dragTargetInfo || {};
      const fieldCode = _fieldCode || store.dragTargetCode;

      if (!store.dragTargetInfo) {
        return false;
      }
      return [controlCode, fieldCode].every(type => !FIXED_SORT_FIELDS.includes(type));
      // return true;
      // return !store.dragTargetInfo?.requiredFlag; // 必填则不可以移除布局
    };

    const isHighlight = computed(() => {
      return store.isDragging && dragPutInspection();
    });

    // 删除字段
    const onDeleteField = async (field: LayoutFieldItem) => {
      await store.onDelete(field, () => store.deletedFieldsInArea(field, toRef(store, 'unusedAreaFields')));
    };

    const showEmpty = computed<boolean>(() => !fields.value?.length && !store.isDragging);

    return {
      fields,
      searchVo,
      isHighlight,
      loading: toRef(store, 'fieldsLoading'),
      createLoading: toRef(store, 'checkAddLoading'),
      showEmpty,
      isSearching,
      onUpdate,
      dragPutInspection,
      onDeleteField,
      debouncedDelete: useDebounceFn(onDeleteField, 500)
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
